import React, { useState } from "react";
import styled from "styled-components";
import Financials from "./financials";
import { Row, Col } from "components/shared/layout";
import Button from "components/button";
import Select from "components/select";
import Layout, { Header } from "../../shared/card-layout";
import { connect } from "formik";
import Modal, { ModalContent, ModalContext } from "components/modal";
import DropZone from "components/dropzone";
import UploadedFile from "components/uploaded-file";

const FormsContainer = styled.div`
  width: 100%;
`;

const QuestionGroup = styled(Row)`
  margin-bottom: 50px;
`;

const FieldWrapper = styled(Col)`
  padding: 10px;
`;

const ButtonWrapper = styled.div`
  margin: 25px auto;
  button {
    min-width: 13.75em;
  }
`;

const uploadType = {
  score_card: 'score_card_proof',
  quality_plan: 'quality_plan_proof',
  standard_operating_procedures: 'standard_operating_procedures_proof',
  non_compliant_products: 'non_compliant_products_proof',
  corrective_action_plan: 'corrective_action_plan_proof',
  preferential_suppliers: 'preferential_suppliers_proof',
  equipment_register: 'equipment_register_proof',
};

let Level1Form = ({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation have a Balance Score card/KPIs' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_score_card"
                  placeholder={"Score Card?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation have a quality management plan/frame work?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_quality_plan"
                  placeholder={"Quality Plan?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation have standard
operational procedures for ensuring that
products/services are delivered to the stated specifications?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_standard_operating_procedures"
                  placeholder={"SOPs?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation manage product/
service that don’t comply with stated specifications?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_non_compliant_products"
                  placeholder={"Non Compliant Products?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
          </Layout>
        </Col>
        <Col xs={12} lg={6} style={{ height: 'fit-content'}}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation maintain records of
non-conforming product/services and
implementation of corrective action implemented?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_corrective_action_plan"
                  placeholder={"Corrective Action Plan?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation have a list of prefential suppliers?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_preferential_suppliers"
                  placeholder={"Preferential Suppliers?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Does the organisation have an equipment/Assets register?' required />
              <FieldWrapper xs={12} md={6}>
                <Select
                  name="has_equipment_register"
                  placeholder={"Assets Register?"}
                  options={[
                    {
                      label: 'Yes',
                      value: 'yes'
                    },
                    {
                      label: 'No',
                      value: 'no'
                    }
                  ]}
                />
              </FieldWrapper>
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
};

Level1Form = connect(Level1Form);

let Level2Form = ({ formik, editable = true }) => {
  const [showUploadType, setShowUploadType] = useState(false);

  return (
    <FormsContainer>
      <Row xs={12}>
        <Col xs={12} lg={6}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of Balance Score card/KPIs' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.score_card_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.score_card_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.score_card_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("score_card_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.score_card_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.score_card)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.score_card && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of quality management plan/frame work' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.quality_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.quality_plan_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.quality_plan_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("quality_plan_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.quality_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.quality_plan)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.quality_plan && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of a standard
operational procedures for ensuring that
products/services are delivered to the stated specifications' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.standard_operating_procedures_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.standard_operating_procedures_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.standard_operating_procedures_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("standard_operating_procedures_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.standard_operating_procedures_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.standard_operating_procedures)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.standard_operating_procedures && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of method of handling non-compliant product/
services' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.non_compliant_products_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.non_compliant_products_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.non_compliant_products_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("non_compliant_products_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.non_compliant_products_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.non_compliant_products)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.non_compliant_products && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>

        <Col xs={12} lg={6} style={{ height: 'fit-content'}}>
          <Layout>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of corrective action plan for non-conforming products/services' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.corrective_action_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.corrective_action_plan_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.corrective_action_plan_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("corrective_action_plan_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.corrective_action_plan_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.corrective_action_plan)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.corrective_action_plan && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload list of prefential suppliers' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.preferential_suppliers_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.preferential_suppliers_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.preferential_suppliers_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("preferential_suppliers_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.preferential_suppliers_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.preferential_suppliers)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.preferential_suppliers && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
            <QuestionGroup xs={12}>
              <Header title='Upload proof of equipment/Assets register' required />
              <FieldWrapper xs={12} md={6}>
                {formik.values.equipment_register_proof?.fileURL && (
                    <ButtonWrapper>
                      <UploadedFile
                        fileName={
                          formik.values.equipment_register_proof?.file?.path || "View proof"
                        }
                        fileURL={formik.values.equipment_register_proof?.fileURL || ""}
                        onRemove={
                          editable
                            ? () => formik.setFieldValue("equipment_register_proof", null)
                            : null
                        }
                      />
                    </ButtonWrapper>
                )}
                {(editable) && !formik.values.equipment_register_proof?.fileURL && (
                    <ButtonWrapper>
                      <Button variant='zltoLightBlue' onClick={() => setShowUploadType(uploadType.equipment_register)}>
                        Upload proof
                      </Button>
                    </ButtonWrapper>
                )}
              </FieldWrapper>
              {showUploadType === uploadType.equipment_register && (
                <Modal onClose={() => setShowUploadType(false)}>
                  <ModalContent>
                    <ModalContext.Consumer>
                      {({ closeModal }) => (
                        <DropZone name={showUploadType} closeModal={closeModal} />
                      )}
                    </ModalContext.Consumer>
                  </ModalContent>
                </Modal>
              )}
            </QuestionGroup>
          </Layout>
        </Col>
      </Row>
    </FormsContainer>
  );
};

Level2Form = connect(Level2Form);

export {
  Level1Form,
  Level2Form,
};
